
import visaBackground from '../../images/backgroundVisa.png'; 
import AmexBackground from '../../images/backgroundAmex.png'; 
import MasterCardBackground from '../../images/backgroundMasterCard.png'; 
import JcbCardBackground from '../../images/backgroundJcb.png'; 
import discoverCardBackground from '../../images/backGroundDiscover.png'; 
import UnionPayCardBackground from '../../images/backGroundUnionPay.png'; 
import DinersCardBackground from '../../images/backgroundDiners.png'; 


const CardBrandBackgroundImage = ({ brand }) => {
  switch (brand) {
    case 'visa':
      return visaBackground;
    case 'amex':
      return AmexBackground;
    case 'mastercard':
      return MasterCardBackground;
      case 'discover':
      return discoverCardBackground;
    case 'diners':
      return DinersCardBackground;
    case 'jcb':
      return JcbCardBackground;
    case 'unionpay':
      return UnionPayCardBackground;
    default:
      return '';  
  }
};

export default CardBrandBackgroundImage;
